





import { defineComponent } from '@nuxtjs/composition-api'
import PlansBenchmark from '~/components/solepro/ProductPage/PlansBenchmark/PlansBenchmark.vue';

export default defineComponent({
      props: {
        node: {
            type: Object,// @TODO define type
            required: true
        }
    },
    components:{
        PlansBenchmark
    },
    setup(props) {
        const content = props.node.DOMContent.outerHTML;
        return {
            content,
            inverted: props.node.cssClasses.includes('inverted')
        }
        
    },
})
